import { render } from "./HolidayManager.vue?vue&type=template&id=5b622a31&scoped=true"
import script from "./HolidayManager.vue?vue&type=script&lang=js"
export * from "./HolidayManager.vue?vue&type=script&lang=js"

import "./HolidayManager.vue?vue&type=style&index=0&id=5b622a31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b622a31"]])

export default __exports__